/**
 * Supported social media platforms for sharing
 */
export type SocialPlatform = "linkedin" | "twitter" | "facebook";

/**
 * Configuration for social media sharing URLs
 */
interface SocialMediaConfig {
  baseUrl: string;
  queryParams: {
    text?: string;
    url?: string;
    title?: string;
    [key: string]: string | undefined;
  };
}

// "https://www.linkedin.com/feed/?shareActive&mini=true&text=",

/**
 * Base configuration for different social media platforms
 */
const SOCIAL_MEDIA_CONFIGS: Record<SocialPlatform, SocialMediaConfig> = {
  linkedin: {
    baseUrl: "https://www.linkedin.com/sharing/share-offsite",
    queryParams: {},
  },
  twitter: {
    baseUrl: "https://twitter.com/intent/tweet",
    queryParams: {
      url: window.location.href,
    },
  },
  facebook: {
    baseUrl: "https://www.facebook.com/sharer/sharer.php",
    queryParams: {},
  },
};

/**
 * Generates a sharing URL for the specified social media platform
 * @param platform - The social media platform to generate the URL for
 * @param text - The text content to share
 * @returns The generated sharing URL or empty string for unsupported platforms
 */
export function generateSocialShareUrl(platform: SocialPlatform, data?: string): string {
  const config = SOCIAL_MEDIA_CONFIGS[platform];

  if (!config.baseUrl) {
    return "";
  }

  const params = new URLSearchParams();
  const queryParams = { ...config.queryParams };

  if (data) {
    switch (platform) {
      case "linkedin":
        queryParams.text = data;
        break;
      case "twitter":
        queryParams.text = data;
        queryParams.hashtags = "#nextwork";
        break;
      case "facebook":
        queryParams.u = data;
        break;
    }
  }

  // Add all query parameters to the URL
  Object.entries(queryParams).forEach(([key, value]) => {
    if (value) {
      params.append(key, value);
    }
  });

  return `${config.baseUrl}?${params.toString()}`;
}
